(function () {
  var sectionSelector = '[data-collection-seo]';

  function setExpanded(section, expanded) {
    var body = section.querySelector('[data-collection-seo-body]');
    var toggle = section.querySelector('[data-collection-seo-toggle]');
    var label = section.querySelector('[data-collection-seo-toggle-label]');

    if (!body || !toggle || !label) return;

    body.classList.toggle('is-collapsed', !expanded);
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    label.textContent = expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore;
  }

  function updateOverflow(section) {
    var body = section.querySelector('[data-collection-seo-body]');
    var toggle = section.querySelector('[data-collection-seo-toggle]');

    if (!body || !toggle) return;

    var wasExpanded = toggle.getAttribute('aria-expanded') === 'true';
    body.classList.add('is-collapsed');

    var hasOverflow = body.scrollHeight > body.clientHeight + 2;
    toggle.hidden = !hasOverflow;

    if (!hasOverflow) {
      setExpanded(section, false);
      body.classList.remove('is-collapsed');
    } else if (wasExpanded) {
      body.classList.remove('is-collapsed');
    }
  }

  function initializeSection(section) {
    if (!section || section.dataset.collectionSeoInitialized === 'true') return;

    var toggle = section.querySelector('[data-collection-seo-toggle]');
    if (!toggle) return;

    section.dataset.collectionSeoInitialized = 'true';
    updateOverflow(section);

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      setExpanded(section, !expanded);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        updateOverflow(section);
      }, 150);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        updateOverflow(section);
      });
    }
  }

  function initialize(root) {
    if (root.matches && root.matches(sectionSelector)) {
      initializeSection(root);
    }

    root.querySelectorAll(sectionSelector).forEach(initializeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
